<div id="allUserContainer">
  <div class="row">
    <div class="col-md">
      <h2>{{ "COMPONENTS.USERS.TITLE" | translate }}</h2>
    </div>
  </div>
  <button mat-raised-button [routerLink]="['/content/coordinator/new-coach']">{{ "COMPONENTS.USERS.ADD_USER_BUTTON" | translate }}</button>
  <div class="d-flex justify-content-between flex-wrap gap-3 my-3" [formGroup]="filterToggles">
    <mat-slide-toggle class="text-start" formControlName="statusToggle" (change)="usersTable.update()">{{ "COMPONENTS.USERS.STATUS_TOGGLE" | translate }}</mat-slide-toggle>
    <mat-slide-toggle class="text-start" formControlName="rolesToggle" (change)="usersTable.update()">{{ "COMPONENTS.USERS.ROLES_TOGGLE" | translate }}</mat-slide-toggle>
    <mat-slide-toggle class="text-start" formControlName="registeredToggle" (change)="usersTable.update()">{{ "COMPONENTS.USERS.REGISTER_TOGGLE" | translate }}</mat-slide-toggle>
  </div>
  <div class="row">
    <div class="col-md">
      <app-table
        #usersTable
        id="USERS"
        [data]="users"
        [search]="true"
        [pageSizes]="[5, 10, 25]"
        [customFilter]="getFilterFunction()"
        [headers]="headers"
      ></app-table>
    </div>
  </div>
</div>
